<script>

    import { toast } from 'bulma-toast'

    import ZipcodesService from '../$services/zipcodes.service'
    import Spinner from '../$components/spinner.svelte'

    import InputText from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'
    import Switch from '../$components/switch.svelte'

    export let zipcode;
    export let state;
    export let city;
    export let municipality;
    export let colony;

    export let disabled = false;

    let colonies = []
    let loading = false
    let showInput = false

    $: colonyOptions = colonies.map(item => ({ value: item, text: item }))

    if(zipcode && !colony)
        findZipcode()

    if(zipcode && colony)
        findZipcode(false)

    if(disabled && !zipcode)
        disabled = false

    async function findZipcode(deleteColony = true) {

        state = ''
        city = ''
        municipality = ''
        colony = deleteColony? '' : colony
        colonies = []

        if(zipcode.length != 5)
            return

        loading = true
        const resp = await ZipcodesService.getZipcodeColony(zipcode)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        if(!resp.data)
            return toast({message: 'No se encontro información del código postal', type: 'is-danger'})

        state = resp.data.state
        city = resp.data.city
        municipality = resp.data.municipality
        colonies = resp.data.colony || []

        if(colony) {
            const inColonies = colonies.find(item => item === colony)
            showInput = !inColonies
        }
    }

</script>

<Spinner {loading} />

{#if !loading}
    <div class="columns">
        <div class="column">
            <InputText bind:value={zipcode} label="Codigo postal" placeholder="Código postal" {disabled} required />
        </div>
        <div class="column">
            <InputText bind:value={state} label="Estado" placeholder="Estado" {disabled} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={city} label="Ciudad" placeholder="Ciudad" {disabled} />
        </div>
        <div class="column">
            <InputText bind:value={municipality} label="Municipio" placeholder="Municipio" {disabled} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            {#if colonies.length && !showInput}
                <Select bind:value={colony} label="Colonia" text="Selecciona una colonia" options={colonyOptions} required />
            {:else}
                <InputText bind:value={colony} label="Colonia" placeholder="Colonia" required />
            {/if}
            {#if colonies.length}
                <Switch bind:checked={showInput} label="Otra colonia" />
            {/if}
        </div>
    </div>
{/if}
